import * as fp from 'lodash/fp';

export default fp.pipe<[string], number, string>(
  (v: string) => v.length,
  fp.cond([
    [fp.gte(1), fp.always('名稱不能小於一個字')],
    [fp.T, fp.always('')],
  ]),
);
